import React, { createContext, useState, useEffect } from 'react';
import { ROLES } from '../ai_config/Role';

export const RoleContext = createContext();

const RoleProvider = ({ children }) => {
  const [customRoles, setCustomRoles] = useState([]);

  useEffect(() => {
    const savedCustomRoles = localStorage.getItem('customSidekicks');
    if (savedCustomRoles) {
      setCustomRoles(JSON.parse(savedCustomRoles));
    }
  }, []);

  const addCustomRole = (newRole) => {
    const updatedCustomRoles = [...customRoles, newRole];
    setCustomRoles(updatedCustomRoles);
    localStorage.setItem('customSidekicks', JSON.stringify(updatedCustomRoles));
  };

  const allRoles = { ...ROLES, ...customRoles.reduce((acc, role) => {
    acc[role.title] = role;
    return acc;
  }, {}) };

  return (
    <RoleContext.Provider value={{ roles: allRoles, addCustomRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export default RoleProvider;